module.exports = __webpack_public_path__ + "static/gender-equality-icon-2025-7ae770026b2ab6a4a2dda64e2f7fabd5.png";